import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {TranslateModule} from '@ngx-translate/core';
import {ResourcePageStatus} from '../../../core/services/resource-page-state.service';

@Component({
  selector: 'app-resource-page-status',
  standalone: true,
  imports: [CommonModule, RouterModule, ButtonModule, TranslateModule],
  templateUrl: './resource-page-status.component.html',
  styleUrls: ['./resource-page-status.component.scss'],
})
export class ResourcePageStatusComponent {
  @Input() status: ResourcePageStatus | null = null;
  @Output() retry = new EventEmitter<void>();
}
